<template>
  <svg :width="width"
       :height="height"
       role="presentation"
       viewBox="0 0 16 16"
       @click="$emit('click')">
    <path d="M5.248 10.543a5.866 5.866 0 0 0 2.356.677c.045.57.163 1.174.387 1.78H3.003A1.002 1.002 0 0 1 2 12.004V3.996C2 3.448 2.451 3 3.003 3H8c-.444 1.05-1.476 3.651-1.476 5.156v.498h1.294a8.61 8.61 0 0 0-.226 1.565 4.867 4.867 0 0 1-1.868-.552.503.503 0 0 0-.679.202.496.496 0 0 0 .203.674zM5.056 5.7v.623a.43.43 0 0 0 .43.428.43.43 0 0 0 .432-.428V5.7a.43.43 0 0 0-.431-.428.43.43 0 0 0-.431.428zm7.93-2.7c.558 0 1.015.448 1.014.996v8.008c0 .548-.457.996-1.014.996H8.913a.488.488 0 0 0-.032-.222 5.482 5.482 0 0 1-.367-1.575 5.971 5.971 0 0 0 2.315-.722.493.493 0 0 0 .19-.679.512.512 0 0 0-.692-.186 4.949 4.949 0 0 1-1.823.587 7.233 7.233 0 0 1 .358-1.873l.257-.672H7.455C7.678 6.004 8.829 3.382 9 3h3.986zm-1.971 3.33v-.622a.432.432 0 0 0-.437-.428.432.432 0 0 0-.436.428v.622c0 .236.196.428.436.428.241 0 .437-.192.437-.428z" :fill="disabled ? disabledStateColor : iconColor" fill-rule="nonzero"/>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>